module.exports = __webpack_public_path__ + "img/cmsign_rule.c2e63ee8.png";